import {Component} from "../../../../sedestral/framework/interface/component/Component";
import * as s from "./modal.scss";
import {SedestralInterface} from "../../../../sedestral/framework/interface/SedestralInterface";
import {Network} from "../../../../network/Network";
import {isMobile} from "../../../../sedestral/framework/utilities/IsMobile";
import {SedestralMachine} from "../../../../sedestral/framework/machine/SedestralMachine";

export class VisualModalComponent extends Component {
    public modalTemplate: string;
    public modalStyle: string;
    public modalClass: string;
    public name: string;
    private static readonly HEAD_MARGIN = 15;

    public headMargin: boolean;

    public headContainer: Component;
    public contentContainer: Component;
    public modalContainer: Component;
    public nameContainer: Component;
    public boxContainer: Component;
    public visualModal: Component;
    public modalHeight: number;

    public closeButton: Component;

    public fixed: boolean;
    public fixedWithTitle: boolean;
    public noOutsideClick: boolean;
    public autoResize: boolean;
    public noTitle?: boolean;

    constructor(modalClass?: string) {
        super();
        this.modalClass = modalClass;
        this.modalTemplate = `<div>template</div>`;
        this.modalStyle = "width:360px;"
        this.name = "name";

        this.template = `
            <div class="${s.visualModal} ${this.modalClass ? s[this.modalClass] : ``}">
                <div class="${s.box}">
                    <div class="${s.modalHead}">
                        <div class="${s.name}"></div>
                        <div class="${s.CloseButton} ${s.round}">
                            <div class="${s.icon}"></div>
                        </div>
                    </div>
                    <div class="${s.modalContent}"></div>
                </div>
            </div>
        `;
    }

    commit(): void {
        this.visualModal = this.el(s.visualModal);
        this.headContainer = this.el(s.modalHead);
        this.boxContainer = this.el(s.box);
        this.nameContainer = this.el(s.name);
        this.contentContainer = this.el(s.modalContent);
        this.closeButton = this.el(s.CloseButton);

        this.nameContainer.setHtml(this.name);
        this.modalContainer = this.contentContainer.append(this.modalTemplate);

        this.boxContainer.onOutsideClick(() => {
            if (!SedestralInterface.body.getAttribute("data-scroll")) {
                if (!this.fixed && !this.fixedWithTitle && !this.noOutsideClick)
                    this.close();
            }
        });
        this.closeButton.onClick(() => {
            this.close();
        });

        if (this.modalStyle) {
            this.boxContainer.setStyle(this.modalStyle);
        }

        if (this.headMargin) {
            this.headContainer.setStyle(`margin-bottom:${VisualModalComponent.HEAD_MARGIN}px;`);
            this.contentContainer.setStyle(`height:calc(100% - ${this.headContainer.getHeight() + VisualModalComponent.HEAD_MARGIN}px);`);
        }

        if (this.fixed)
            this.headContainer.remove();

        if (this.fixedWithTitle) {
            if (!isMobile())
                this.setStyle(`background: white;`);
            this.closeButton.remove();
            Network.router.pages.onPopState(this, () => this.close());
        }

        if (this.noTitle) {
            this.addClass(s.noTitle);
        }

        SedestralMachine.requestFrame()(() => this.resize());

        if (this.autoResize) {
            this.onResize(() => this.timeOut(() => this.resize(), 50));
            this.timeOut(() => this.resize(), 250);
        }

        this.animateOpen();

        this.maxZindex();
        super.commit();
    }

    resize() {
        let margin = this.headContainer.getHeight() + this.boxContainer.getPaddingHeight();
        if (this.headMargin) {
            margin += VisualModalComponent.HEAD_MARGIN;
        }
        let fullHeight = this.modalContainer.getHeightCalculated();
        let firstChild = this.contentContainer.getHTMLElement().firstChild;
        if (firstChild) {
            let style = window.getComputedStyle(firstChild as any);
            fullHeight += parseInt(style.marginTop) || 0;
        }

        if (this.noTitle)
            margin = 0;

        if (Math.abs((this.modalHeight || 0) - fullHeight) < margin) {
            return;
        }

        this.modalHeight = fullHeight;

        if ((fullHeight + margin + 80) > window.innerHeight) {
            this.boxContainer.setStyle(`height: ${window.innerHeight - 80}px;`);
        } else {
            this.boxContainer.setStyle(`height:${fullHeight + margin}px`);
        }
    }

    async close(): Promise<void> {
        await this.animateClose();
        this.onClose();
        if (!this.isNull()) {
            this.remove();
        }
    }

    screenRender() {
        SedestralInterface.body.render(this);
    }

    screenPreRender() {
        SedestralInterface.body.prerender(this);
    }

    excludeOutsideClickComponent(component: Component) {
        this.boxContainer.excludeOutsideClickComponent(component);
    }

    /**
     * animate
     */
    public async animateOpen(): Promise<void> {
        if (isMobile()) {
            this.displayShow();
            this.boxContainer.setStyle(`transform:translateY(100%) scale(1);opacity:1;`);
            await this.boxContainer.translate({translateY: 0, delay: 250});
        } else {
            this.boxContainer.scale(0.8, 1, 80);
            this.boxContainer.fade("in", 100);
        }

        this.boxContainer.timeOut(() => {
            this.boxContainer.setStyle("transform:unset;");
        }, 150);
    }

    public async animateClose(): Promise<void> {
        if (isMobile()) {
            await this.boxContainer.wait([
                this.boxContainer.translate({translateY: 150, delay: 80}),
                this.boxContainer.fade("out", 80),
                this.fade("out", 80)
            ]);
        } else {
            await this.boxContainer.wait([
                this.boxContainer.scale(1, 0.9, 50),
                this.boxContainer.fade("out", 80),
                this.fade("out", 80)
            ]);
        }
    }

    /**
     * override
     */

    public onClose(): void {

    }
}